import React from "react";
import Dropdown from "../DropDown";

interface UnitsDropdownProps {
  selectedUnits: string;
  onUnitsChange: (selectedUnits: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const UnitsDropdown: React.FC<UnitsDropdownProps> = ({
  selectedUnits,
  onUnitsChange,
  className = "",
  disabled,
  onFocus,
}) => {

  const options = [
    { value: "$", label: "$" },
    { value: "$/MWh", label: "$/MWh" },
    { value: "Binary", label: "Binary" },
    { value: "$/MMBtu", label: "$/MMBtu" },
    { value: "m/sec", label: "m/sec" },
    { value: "MMBtu", label: "MMBtu" },
    { value: "MWh", label: "MWh" },
    { value: "Timestamp", label: "Timestamp" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedUnits}
      onValueChange={onUnitsChange}
      disabled={disabled}
      className={className}
      placeholder="Select Units"
      onFocus={onFocus}
    />
  );
};

export default UnitsDropdown;
